import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { CheckboxFormField, GridItem, GridContainer, FormSection, AlertSpg } from "@duosoftbg/nacid-components";
import { NaturalPersonNamesFormFields } from "@duosoftbg/nacid-frontoffice-components";
import { useTranslation } from "react-i18next";

const DiplomaNamesFormSection = ({
  infoText = null,
  label = "t.diplomaNames.details",
  checkboxLabel = "l.person.diplomaNames.different",
}) => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();
  useWatch({ name: "diplomaNamesDifferent" });

  return (
    <FormSection label={label}>
      <GridContainer spacing={4} mt={0}>
        <GridItem md={6}>
          <CheckboxFormField labelCode={checkboxLabel} fieldName={"diplomaNamesDifferent"} />
        </GridItem>
      </GridContainer>

      {getValues().diplomaNamesDifferent ? (
        <GridContainer spacing={4} mt={0}>
          {infoText && (
            <GridItem xs={12} sm={12} md={12}>
              <AlertSpg severity={"info"}>{t(infoText)}</AlertSpg>
            </GridItem>
          )}
          <NaturalPersonNamesFormFields
            baseField={"diplomaNames"}
            firstNameRequired={true}
            middleNameRequired={false}
            lastNameRequired={true}
          />
        </GridContainer>
      ) : null}
    </FormSection>
  );
};

export default DiplomaNamesFormSection;
